import { render, staticRenderFns } from "./CentralBottlenecksSection.vue?vue&type=template&id=e4699f22&scoped=true"
import script from "./CentralBottlenecksSection.vue?vue&type=script&lang=js"
export * from "./CentralBottlenecksSection.vue?vue&type=script&lang=js"
import style0 from "./CentralBottlenecksSection.vue?vue&type=style&index=0&id=e4699f22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4699f22",
  null
  
)

export default component.exports